import request from '@/service/http'
import type { BotListReq, BotListRes } from '../types/getBotList'

// 在此处做映射
export function getBotListApi(params: BotListReq): Promise<BotListRes> {
  return request<BotListRes, BotListReq>({
    url: '/api/robot/',
    method: 'get',
    params: params
  })
}
